import { Component, OnInit, Input, Output } from '@angular/core';
import {Router} from "@angular/router";



@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {

    @Input() user = [];

    @Input() atualPage;

    constructor(
        private router: Router
    ) { }

    ngOnInit() {
    }

}
